module.exports = __webpack_public_path__ + "img/gps.f089fa6d.svg";